import { Component, OnInit, OnDestroy } from '@angular/core';
import { DocumentModalService } from 'src/app/provide/document-modal.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-document-modal',
    templateUrl: './document-modal.component.html',
    styleUrls: ['./document-modal.component.scss'],
    standalone: false
})
export class DocumentModalComponent implements OnInit, OnDestroy {
  showModal = false;
  documentContent: any = null;
  private subscriptions: Subscription[] = [];

  constructor(private documentModalService: DocumentModalService) { }

  ngOnInit(): void {
    // Subscribe to modal visibility changes
    this.subscriptions.push(
      this.documentModalService.showModal$.subscribe(show => {
        this.showModal = show;
      })
    );

    // Subscribe to document content changes
    this.subscriptions.push(
      this.documentModalService.documentContent$.subscribe(content => {
        if (content) {
          this.documentContent = content;
        }
      })
    );
  }

  ngOnDestroy(): void {
    // Clean up subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Close the modal
   */
  closeModal(): void {
    this.documentModalService.hideDocumentModal();
  }
} 